import { getApiClient } from '../../axios-config';

/**
 * Project Documents (#250) status: whether the feature is switched on for
 * this deployment. GET /api/ai/project-docs/status is the only #250
 * endpoint that answers while the feature is off (super admins only).
 */
class ProjectDocumentsStatusAPI {
  /** @returns {Promise<boolean>} true only when the server says enabled: true */
  static async isEnabled(token) {
    const response = await getApiClient(token).get(
      '/api/ai/project-docs/status'
    );
    return response.data?.data?.enabled === true;
  }
}

export default ProjectDocumentsStatusAPI;
